import { GetStaticProps } from 'next';
import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { ISecurityWaitingTimesPageData } from '../../../features/security-wait-times/domain/models/ISecurityWaitingTimesPageData';
import { SecurityWaitingTimesPage } from '../../../features/security-wait-times/ui/SecurityWaitTimesPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps: GetStaticProps<ISecurityWaitingTimesPageData> =
	createGetStaticPropsWithPage(PassengersPageId.SecurityWaitingTimes);

export default SecurityWaitingTimesPage;
